import { ingredients } from "../data/ingredients";
import { ingredientsTribunal } from "../data/ingredientsTribunal";
import { ingredientsBloodmoon } from "../data/ingredientsBloodmoon";

export const Effects = {
    find(query, options) {
        const {
            effectsVisible,
            mwOn,
            trOn,
            bmOn,
        } = options;

        const mergedIngredients = [
            ...(mwOn ? ingredients : []),
            ...(trOn ? ingredientsTribunal : []),
            ...(bmOn ? ingredientsBloodmoon : []),
        ]

        const effects = [ ...new Set(
            mergedIngredients.flatMap(it => it.effects.slice(0, effectsVisible)))
        ].sort();

        const lowerQuery = query.toLowerCase();

        let startWith = [];
        let include = [];

        effects.forEach(effect => {
            const lowerName = effect.toLowerCase();
            if (lowerName.startsWith(lowerQuery)) {
                startWith.push(effect);
            } else if (lowerName.includes(lowerQuery)) {
                include.push(effect);
            }
        });

        return [ ...startWith, ...include ];
    }
}